<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom card-transparent p-0 ">
        <div class="card-body p-0">
          <!--begin: Wizard-->
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Nav-->
            <div class="wizard-nav">
              <div class="wizard-steps">
                <div
                  class="wizard-step"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-wrapper">
                    <div class="wizard-label">
                      <div class="wizard-title">
                        Api
                      </div>
                      <div class="wizard-desc">
                        Thêm imei từ nhanh
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-wrapper">
                    <div class="wizard-label">
                      <div class="wizard-title">
                        Excel
                      </div>
                      <div class="wizard-desc">
                        Thêm nhiều imei
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--end: Wizard Nav -->

            <!--begin: Wizard Body-->
            <div class="card card-custom card-shadowless rounded-top-0">
              <div class="card-body p-0">
                <div
                  class="row justify-content-center py-8 px-8 py-lg-15 px-lg-10"
                >
                  <div class="col-12">
                    <!--begin: Wizard Form-->

                    <!--begin: Wizard Step 1-->
                    <div
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                    >
                      <div class="col-12 row" style="padding-left: 0px">
                        <b-form-group class="col-12">
                          <b>Tìm Kiếm :</b>
                          <span class="text-primary">(imei)</span>
                          <b-input-group label="Id nhanh:">
                            <b-form-input
                              type="text"
                              required
                              v-model="imeiNhanh"
                              size="sm"
                              class="col-4"
                              placeholder="Nhập imei"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                variant="primary"
                                size="sm"
                                @click="getImeiNhanh()"
                              >
                                <i class="fa fa-search" aria-hidden="true"></i>
                                Tìm trên Nhanh
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <small class="text-danger"
                            >(Yêu cầu nhập đúng mã imei)</small
                          >
                          <div v-html="findImeiNhanh"></div>
                        </b-form-group>
                      </div>
                      <span class="font-weight-bolder mb-4"
                        >Danh sách imei:</span
                      >
                      <b-table
                        class="table-bordered table-hover col-md-12"
                        :fields="fields"
                        :items="listImei"
                        v-if="renderComponent"
                      >
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-danger text-center"
                            @click="deleteItemInArray(row.item.imeiNo, null)"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </b-table>
                      <div class="mb-5 mt-5">
                        <button
                          v-show="listImei.length > 0"
                          v-bind:style="btnCreate"
                          type="button"
                          class="btn btn-primary font-weight-bolder btn-sm button"
                          @click="createImei()"
                        >
                          Cập nhật
                        </button>
                      </div>
                    </div>
                    <!--end: Wizard Step 1-->

                    <!--begin: Wizard Step 2-->
                    <div class="pb-5" data-wizard-type="step-content">
                      <div>
                        <!-- Styled -->
                        <b-form-file
                          v-model="fileExcel"
                          :state="Boolean(fileExcel)"
                          placeholder="Chọn file hoặc thả file..."
                          drop-placeholder="Drop file here..."
                          accept=".xlsx, .xls, .csv"
                          v-on:change="getFile()"
                          ref="file"
                          class="mb-3 col-5"
                        >
                        </b-form-file>
                        <div v-show="fileExcel">
                          File được chọn:
                          <b>{{ fileExcel ? fileExcel.name : '' }}</b>
                        </div>
                        <div class="mb-3">
                          <b-button
                            variant="warning"
                            size="sm"
                            @click="uploadExcel()"
                            v-show="fileExcel"
                          >
                            Upload
                          </b-button>

                          <b-button
                            class="ml-1"
                            variant="success"
                            size="sm"
                            @click="getImeisFromNhanh()"
                            v-show="listImeiExcel.length > 0"
                          >
                            Lấy api nhanh
                          </b-button>
                        </div>

                        <!-- Plain mode -->
                      </div>
                      <b-table
                        class="table-bordered table-hover col-md-12"
                        :fields="fieldExcels"
                        :items="listImeiExcel"
                        v-if="renderComponent"
                      >
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-warning text-center"
                            @click="getImeiVariant(row.item)"
                            v-b-tooltip
                            title="Lấy imei cha con"
                            >mdi-settings</v-icon
                          >
                          <v-icon
                            small
                            class="text-danger text-center"
                            @click="deleteItemInArray(row.item.imeiNo, 'excel')"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </b-table>
                      <div class="mb-5 mt-5">
                        <button
                          v-show="listImeiExcel.length > 0"
                          v-bind:style="btnCreate"
                          type="button"
                          class="btn btn-primary font-weight-bolder btn-sm button"
                          @click="createImei('excel')"
                        >
                          Cập nhật
                        </button>
                      </div>
                    </div>
                    <!--end: Wizard Step 2-->

                    <!--begin: Wizard Step 3-->

                    <!--end: Wizard Step 3-->

                    <!--begin: Wizard Step 4-->

                    <!--end: Wizard Step 4-->

                    <!--begin: Wizard Actions -->
                    <!--end: Wizard Actions -->

                    <!--end: Wizard Form-->
                  </div>
                </div>
              </div>
            </div>
            <!--end: Wizard Bpdy-->
          </div>
          <!--end: Wizard-->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

import { validationMixin } from 'vuelidate';

import axios from 'axios';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import { cmdUrl } from '../../../utils/apiUrl';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
export default {
  mixins: [validationMixin],
  data() {
    return {
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px'
      },
      fields: [
        {
          key: 'productId',
          label: 'productId Nhanh',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' }
        },
        {
          key: 'productSystemId',
          label: 'productId System',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' }
        },
        {
          key: 'productCode',
          label: 'Mã code',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' }
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' }
        },
        {
          key: 'imeiNo',
          label: 'IMEI',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' }
        },

        {
          key: 'statusName',
          label: 'Trạng thái imei',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%'
          },
          tdClass: 'text-left'
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' }
        },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          formatter: value => {
            return this.formatMoney(value);
          }
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          formatter: value => {
            return this.formatMoney(value);
          }
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%'
          }
        }
      ],
      fileExcel: null,
      fieldExcels: [],
      listImeiExcel: [],
      listImei: [],
      searchStore: '',
      inventorySelected: null,
      inputSearchImeiProp: {
        id: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch imei',
        style: 'border-radius:0px!important',
        disabled: true
      },
      renderComponent: true,
      imeiNhanh: null,
      findImeiNhanh: ''
    };
  },
  created() {
    this.fieldExcels = [...this.fields];
    let imeiNhanh = this.$router.history.current.query.imeiNhanh;
    if (imeiNhanh) {
      this.imeiNhanh = imeiNhanh;
      this.getImeiNhanh();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Đồng bộ imei' }]);
    // Initialize form wizard
    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    wizard.on('beforeNext', function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on('change', function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    formatMoney(number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true
      });
    },
    deleteItemInArray(imeiId, isExcel) {
      let i = 0;
      for (; i < isExcel ? this.listImeiExcel : this.listImei; i++) {
        if (isExcel) {
          if (this.listImeiExcel[i].barCode === imeiId) {
            this.listImeiExcel.splice(i, 1);
            this.makeToastSuccess(`Đã xoá ${imeiId} ra khỏi danh sách`);
          }
        } else {
          if (this.listImei[i].id === imeiId) {
            this.listImei.splice(i, 1);
            this.makeToastSuccess(`Đã xoá ${imeiId} ra khỏi danh sách`);
          }
        }
      }
    },
    getImeiNhanh() {
      this.$router
        .replace({
          query: { imeiNhanh: this.imeiNhanh }
        })
        .catch(() => {});
      this.findImeiNhanh =
        '<p><strong class="text-primary">Loading...</strong><span role="status" class="spinner-grow spinner-grow-sm text-primary"><span class="sr-only">Small Spinner</span></span></p>';

      let url = cmdUrl.ToolSync.imeiSearch;
      axios
        .get(url, {
          params: {
            imei: this.imeiNhanh
          }
        })
        .then(rs => {
          let imeis = [];
          imeis.push(rs.data.data);
          let imeiExists = [];
          let imeiNotExists = [];
          this.findImeiNhanh = '';
          imeis.forEach(x => {
            let exist = this.listImei.find(y => y.imeiNo === x.imeiNo);
            if (exist) {
              imeiExists.push(x);
            } else {
              imeiNotExists.push(x);
            }
          });
          if (imeiNotExists.length > 0) {
            this.listImei = this.listImei.concat(imeiNotExists);
            this.makeToastSuccess(`Đã thêm imei`);
          }
          if (imeiExists.length > 0) {
            this.makeToastSuccess(
              `${imeiExists.map(x => x.imeiNo).join(',\n')} imei đã tồn tại`
            );
            this.findImeiNhanh = '';
          }
        })
        .catch(err => {
          this.makeToastFaile(err.message);
          this.findImeiNhanh = '';
        });
    },
    getImeisFromNhanh() {
      let imeis = this.listImeiExcel;
      if (imeis.length > 0) {
        let list = [];
        for (const item of imeis) {
          let url = cmdUrl.ToolSync.imeiSearch;
          axios
            .get(url, {
              params: {
                name: item.barCode
              }
            })
            .then(rs => {
              if (rs.data.status) {
                list.push(rs.data.data[0]);
              } else {
                this.makeToastFaile(`Sản phẩm ${item.imeiName} lỗi`);
              }
            })
            .catch(err => {
              this.makeToastFaile(err.message);
            });
        }

        this.listImeiExcel = list;
      } else {
        this.makeToastFaile(`Danh sách imei trống`);
      }
    },
    createImei: async function(isExcel) {
      let data = {
        listImei: isExcel ? this.listImeiExcel : this.listImei
      };
      if (data.listImei.length > 0) {
        //console.log(`Data: ${JSON.stringify(data)}`);
        let url = cmdUrl.ToolSync.imei;
        axios
          .post(url, data)
          .then(({ data }) => {
            if (data.status) {
              this.makeToastSuccess(data.message);

              // setTimeout(() => {
              //   this.$router.push({
              //     name: 'list-inventory-balance'
              //   });
              // }, 1000);
            } else {
              this.makeToastFaile(data.message);
              this.isNew = true;
            }
          })
          .catch(({ response }) => {
            this.makeToastFaile(response.$error);
          });
      } else {
        this.makeToastFaile('Vui lòng chọn sản phẩm!');
        this.isNew = true;
      }
    },
    uploadExcel() {
      let formData = new FormData();
      formData.append('file', this.fileExcel);
      let url = cmdUrl.ToolSync.imeiExcel;
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(rs => {
          if (rs.data.status) {
            this.listImeiExcel = rs.data.data;
            this.makeToastSuccess('Đọc file thành công');
          } else {
            this.makeToastFaile('Đọc file thất bại');
          }
        })
        .catch(() => {
          this.makeToastFaile('Đọc file thất bại');
        });
    },
    getFile() {
      this.fileExcel = this.$refs.file.files[0];
    }
  }
};
</script>
<style scoped>
.title-center {
  text-align: center;
}

.input-group-append {
  cursor: pointer;
}

.input-group-append:hover i {
  color: #3699ff;
}

.tdTextAlignPrice {
  text-align: right !important;
  vertical-align: middle;
  font-weight: 600;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
